(() => {
    angular.module('app').component('hostInpatientGuaranteeLettersCommonProvisionalDiagnosisComponent', {
        templateUrl: require('./provisionalDiagnosis.component.html'),
        controller: ProvisionalDiagnosisController,
        controllerAs: 'vm',
        bindings: {
            staticDiagnosis: '<',
            diagnosis: '<',
            isEdit: '<'
        }
    });

    function ProvisionalDiagnosisController() {
        const vm = this;

        vm.$onChanges = onChanges;
        vm.addDiagnosis = addDiagnosis;
        vm.clearDiagnosis = clearDiagnosis;
        vm.lookupIcd = lookupIcd;
        vm.updateDiagnosis = updateDiagnosis;

        vm.filteredIcds = [];

        const limitSize = 30;

        function onChanges(changes) {
            if (changes.isEdit && changes.isEdit.currentValue) {
                if (vm.diagnosis.selected.length < 1) {
                    addDiagnosis();
                }
            }

            // To add code to description for static diagnosis

            if (changes.staticDiagnosis && changes.staticDiagnosis.currentValue) {
                _.each(vm.staticDiagnosis, (d) => {
                    if (d.code)
                        d.description = `(${  d.code  }) ${  d.description}`;
                })
            }

            if (changes.diagnosis && changes.diagnosis.currentValue) {
                _.each(vm.diagnosis.selected, (diagnosis) => {
                    initDiagnosis(diagnosis);
                });
            }
        }

        function addDiagnosis() {
            vm.diagnosis.selected.push({ date: new Date() });
        }

        function clearDiagnosis() {
            vm.diagnosis.selected = [{ date: new Date() }];
        }

        function initDiagnosis(diagnosis) {
            if (diagnosis.description && _.isNil(diagnosis.code)) {
                diagnosis.code = generateId();
            } else {
                const selectedDiagnosis = _.find(vm.diagnosis.icd, { code: diagnosis.code });
                if (selectedDiagnosis) {
                    diagnosis.id = selectedDiagnosis.id;
                    diagnosis.code = selectedDiagnosis.code;
                    diagnosis.description = selectedDiagnosis.description;
                    diagnosis.parentDescription = selectedDiagnosis.parentDescription;
                }
            }
        }

        function updateDiagnosis(diagnosis) {
            const customDiagnosis = _.find(vm.filteredIcds, { code: diagnosis.code });
            if (customDiagnosis) {
                if (diagnosis.code < 0) {
                    diagnosis.code = generateId();
                } else {
                    diagnosis.code = customDiagnosis.code;
                }

                diagnosis.description = customDiagnosis.description;
                diagnosis.parentDescription = customDiagnosis.parentDescription;
            }
            else {
                for (let i = 0; i < vm.diagnosis.selected.length; i++) {
                    if (vm.diagnosis.selected[i].code === undefined) {
                        vm.diagnosis.selected[i] = { date: new Date() };
                    }
                }


            }
            getDiagnoses();
        }

        function generateId() {
            // Set custom diagnosis id to negative number of current time.
            // To resolve ng-change where unable to change custom diagnosis,
            // due to diagnosis listing set to -1 for all custom diagnosis

            return -Math.abs(new Date().getTime());
        }

        function lookupIcd(filter) {
            const keyword = _.trim(filter || '');
            if (keyword) {
                // Include free-text entry in filtered ICD set.

                const filteredIcds = [{
                    item: {
                        description: "",
                    },
                    // Set free-text entry with high negative score
                    // so that it stays as first choice.

                    score: 0 
                }];

                const regexes = _.chain(keyword.split(' '))
                    .map((k) => _.trim(k.toUpperCase()))
                    .filter((k) => k)
                    .uniq()
                    .map((k) => {
                        _.escapeRegExp(k);
                        return {
                            token: k,
                            len: k.length,
                            pattern: new RegExp(`\\b${  k}`, 'i')
                        };
                    })
                    .value();

                _.forEach(vm.diagnosis.icd, (icd) => {
                    let score = 0;

                    // Exclude selected icd.

                    const isSelected = _.find(vm.diagnosis.selected, (s) => s.code === icd.code);

                    if (!isSelected) {
                        _.forEach(regexes, (r) => {
                            if (r.pattern.test(icd.description)) {
                                score -= r.len;
                            }
                        });
                    }

                    if (score) {
                        filteredIcds.push({
                            score,
                            item: icd
                        });
                    }
                });

                vm.filteredIcds = _.chain(filteredIcds)
                    .sortBy(['score'])
                    .take(30)
                    .map((k) => k.item)
                    .uniqBy((s) => s.code)
                    .value();
            }
            else {
                getDiagnoses();
            }
        }

        function getDiagnoses() {
            let tempIcd = [];
            _.forEach(vm.diagnosis.icd, (diagnosis) => {
                const selectedDiagnosis = _.find(vm.diagnosis.selected, { code: diagnosis.code });
                const staticDiagnosis = _.find(vm.staticDiagnosis, { code: diagnosis.code });

                if (!selectedDiagnosis && !staticDiagnosis) {
                    tempIcd.push(diagnosis);
                }
            });

            tempIcd = _.sortBy(tempIcd, x => x.code);
            vm.filteredIcds = _.take(tempIcd, limitSize);
        }
    }
})();
